import React, { memo, SVGProps } from 'react'

export const StatusPending = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 18.9333C8.18133 18.9333 5.06667 15.8187 5.06667 12C5.06667 8.18133 8.18133 5.06667 12 5.06667C15.8187 5.06667 18.9333 8.18133 18.9333 12C18.9333 15.8187 15.8187 18.9333 12 18.9333Z"
      fill="currentColor"
    />
    <path
      d="M12 6.66666C9.05599 6.66666 6.66666 9.05599 6.66666 12C6.66666 14.944 9.05599 17.3333 12 17.3333C14.944 17.3333 17.3333 14.944 17.3333 12C17.3333 9.05599 14.944 6.66666 12 6.66666ZM14.6453 12.8H12C11.5627 12.8 11.2 12.4373 11.2 12V8.77866C11.2 8.34133 11.5627 7.97866 12 7.97866C12.4373 7.97866 12.8 8.34133 12.8 8.77866V11.2H14.6453C15.0827 11.2 15.4453 11.5627 15.4453 12C15.4453 12.4373 15.0827 12.8 14.6453 12.8Z"
      fill="currentColor"
    />
  </svg>
))
